import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { ContentStateSkeleton } from './EditorContentState/ContentStateSkeleton.tsx';
import { RendererContentStatePlaceholder } from './RendererContentState/RendererContentStatePlaceholder.tsx';
import type { WithIntlProps } from 'react-intl';
import type { EditorContentStateProps } from './EditorContentState/types.ts';
import type { RendererContentStateComponentProps } from './RendererContentState/types.ts';

export const LazyEditorContentStateComponent: LoadableType<Omit<EditorContentStateProps, 'flags'>> =
	LoadableAfterPaint({
		loader: async () => {
			return (
				await import(
					/* webpackChunkName: "loadable-EditorContentStateEditorContentStateComponent" */ './EditorContentState/EditorContentStateComponent.tsx'
				)
			).EditorContentStateComponent;
		},
		loading: ContentStateSkeleton,
	});

export const LazyRendererContentStateComponent: LoadableType<
	WithIntlProps<RendererContentStateComponentProps>
> = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-RendererContentStateRendererContentStateComponent" */ './RendererContentState/RendererContentStateComponent.tsx'
			)
		).RendererContentStateComponent;
	},
	loading: RendererContentStatePlaceholder,
});
